<div class="placeholder">
  <div class="placeholder__icon">
    <span nz-icon nzType="ng-zorro:placeholder"></span>
  </div>
  <p class="placeholder__title">No Groups Added Yet</p>
  <p class="placeholder__text">
    Get started in
    <a nz-button nzType="link" class="placeholder__link" routerLink="/groups-manager" (click)="closeModals()">Groups Manager</a>
  </p>
</div>
